import { render, staticRenderFns } from "./DeleteLeads.vue?vue&type=template&id=6d0f8220&scoped=true&"
import script from "./DeleteLeads.vue?vue&type=script&lang=js&"
export * from "./DeleteLeads.vue?vue&type=script&lang=js&"
import style0 from "./DeleteLeads.vue?vue&type=style&index=0&id=6d0f8220&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0f8220",
  null
  
)

export default component.exports